import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-video",
  templateUrl: "./med-icon-video.component.html",
})
export class MedIconVideoComponent extends SvgMixinComponent {}
